module.exports = __webpack_public_path__ + "static/media/enabledStartIcon.d3ca459e.svg";